import api from "./api";

// Admin-only registration workflow visibility (see SFMIS-Backend routes/api.php).
// Unlike listMembers/listClubs (which only show finalized records), these list
// every member_registration_process / club_registration_process row — pending,
// paid-but-unfinalized, and completed alike — with the applicant/club, payment,
// and process-status detail already flattened onto each row.
//
// Consumed by the "Pending Registrations" sub-tab on the Members page
// (member processes, gated in the frontend by "view_member_details") and the
// Clubs page (club processes, gated by "view_club_details") — see
// MembersManagement.jsx / ClubsManagement.jsx. Note the backend routes
// themselves are still gated by middleware('role:admin'), i.e. the top
// "admin" role specifically, not by either of those permissions — a system
// user with "view_member_details"/"view_club_details" but not the Admin role
// will see the tab but get a 403 when it loads. That's a backend-side
// mismatch to resolve separately, not something the frontend can paper over.

// GET /api/member-registration-processes → optional { search,
// process_status_id, payment_status_id, club_verification_status_id } filters.
export const listMemberRegistrationProcesses = (params = {}) =>
  api
    .get("/api/member-registration-processes", { params })
    .then((r) => (Array.isArray(r.data) ? r.data : []));

// GET /api/member-registration-processes/{processId} → single process row.
export const getMemberRegistrationProcess = (processId) =>
  api
    .get(`/api/member-registration-processes/${processId}`)
    .then((r) => (Array.isArray(r.data) ? r.data[0] : r.data));

// GET /api/club-registration-processes → optional { search, process_status_id,
// payment_status_id } filters.
export const listClubRegistrationProcesses = (params = {}) =>
  api
    .get("/api/club-registration-processes", { params })
    .then((r) => (Array.isArray(r.data) ? r.data : []));

// GET /api/club-registration-processes/{processId} → single process row
// (includes a `coaches` array of the club's registered coach applicants).
export const getClubRegistrationProcess = (processId) =>
  api
    .get(`/api/club-registration-processes/${processId}`)
    .then((r) => (Array.isArray(r.data) ? r.data[0] : r.data));
